// Back-compat wrapper for the repair-anchored composer. New surfaces should
// import MessageComposer directly.

import { MessageComposer } from "./MessageComposer";

export function RepairComposer({
  repairId,
  onSent,
}: {
  repairId: string;
  onSent?: () => void;
}) {
  return <MessageComposer anchor={{ kind: "repair", id: repairId }} onSent={onSent} />;
}
